module.exports = __webpack_public_path__ + "img/minus-dark.8db576e6.svg";